import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFilterHeader} from "../../../../interfaces/table-header";

@Component({
  selector: 'smart-table-filter',
  templateUrl: './smart-table-filter.component.html'
})
export class SmartTableFilterComponent implements OnInit {

  @Input() item: IFilterHeader;

  isInput: boolean;
  isSelect: boolean;
  isDate: boolean;

  typingTimeout: any;

  value: any;
  @Output() changed: EventEmitter<IFilterHeader> = new EventEmitter<IFilterHeader>();

  constructor() { }

  ngOnInit(): void {
    this.parserType();
    this.item.pristine = true;
  }

  onChange(value) {
    this.item.value = this.parseValue(value);
    this.item.pristine = false;
    if (this.isInput) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(() => {
        this.changed.emit(this.item);
      }, 800);
    } else {
      this.changed.emit(this.item);
    }

  }

  parserType() {
    this.isInput = this.item.type === 'text' || this.item.type === 'number';
    this.isSelect = this.item.type === 'select';
    this.isDate = this.item.type === 'date';
  }

  parseValue(value) {
    if (this.item.type === 'number') {
      return parseInt(value);
    } else if (this.isDate) {
      return value ? {range: value} : undefined
    }
    return value;
  }
}
